var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { InfoCircleIcon } from "@gemini/icons";
import { Button, Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
const Trigger = (_a) => {
    var rest = __rest(_a, []);
    const { t } = useI18n();
    return (_jsx(Button, Object.assign({ iconOnly: true, icon: InfoCircleIcon, variant: "tertiary", size: "40" }, rest, { children: t("provider.badge.modal.cta") })));
};
export const PartnerBadgesModal = ({ badges, customTrigger, }) => {
    const { t } = useI18n();
    const TriggerComponent = customTrigger || Trigger;
    return (_jsx(Modal, { title: t("provider.badge.modal.title"), isDismissable: true, trigger: TriggerComponent, children: _jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.40", children: badges === null || badges === void 0 ? void 0 : badges.map((badge) => {
                return (_jsxs(Box, { display: "flex", gap: "spacing.16", children: [_jsx(Box, { as: "img", alt: "partner badge", src: badge.imageUrl, width: "sizing.56", height: "sizing.56", borderRadius: "radius.8" }), _jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: [_jsx(Box, { typography: "typography.body.16.bold", children: badge.title }), _jsx(Box, { children: badge.description })] })] }, badge.title));
            }) }) }));
};
